import * as docketPropTypes from "../docketPropTypes";
import appStyles from "../styles/appStyles";
import Button from "./Button";
import CircularProgress from "./mui/CircularProgress";
import history from "../lib/history";
import PropTypes from "prop-types";
import React from "react";
import { css, StyleSheet } from "aphrodite";

const styles = StyleSheet.create({
	loading: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
	},
	message: {
		textAlign: "center",
		width: 400,
		marginTop: 16,
		marginBottom: 16,
		marginLeft: "auto",
		marginRight: "auto",
	},
	button: {
		display: "block",
	},
});

const strings = {
	errorMessage:
		"Something went wrong loading the application. Please check your network connection and try again.",
	tryAgain: "Try Again",
};

function retry() {
	history.go();
}

export default function Loading({ aStyles, error, pastDelay, loadingMessage }) {
	if (error) {
		if (__DEV__) {
			console.warn(error);
		}
		return (
			<div className={css(styles.loading, aStyles)}>
				<div className={css(appStyles.baseFont, styles.message)}>
					{strings.errorMessage}
				</div>
				<Button aStyles={styles.button} onClick={retry}>
					{strings.tryAgain}
				</Button>
			</div>
		);
	}
	if (pastDelay) {
		return (
			<div className={css(styles.loading, aStyles)}>
				<CircularProgress />
				{loadingMessage ? (
					<div className={css(appStyles.baseFont, styles.message)}>{loadingMessage}</div>
				) : null}
			</div>
		);
	}
	return null;
}

Loading.propTypes = {
	aStyles: docketPropTypes.aphroditeStyles,
	error: PropTypes.instanceOf(Error),
	loadingMessage: PropTypes.string,
	pastDelay: PropTypes.bool,
};

Loading.defaltProps = {
	pastDelay: false,
};
